import { Component, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpClient } from 'selenium-webdriver/http';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";
import { IzvestajService } from "app/izvestaj/izvestaj.service";

@Component({
  selector: 'app-table',
  templateUrl: './izvestaj.component.html',
  providers:[IzvestajService]
})
export class IzvestajComponent implements OnInit {

  products: any[] = [
    {
      "productId": 2,
      "productName":"Garden Cart"
    }
  ]

  constructor(private http: Http, private tableService: IzvestajService) { 
  }
  getResult: string;
  
  DataArray: any = [];

  /*  sendForFind(find:string) {
    console.log(find);

    this.http.get('http://localhost:8000/getclient/' + find)
            .subscribe(data => {
                this.getResult = data['_body'];
                console.log(data['_body']);
              });


  }*/

sendForFind(find:string) {
    console.log(find);

     this.tableService.sendForFind(find).subscribe(
      data => {
        this.DataArray = data;
        console.log(data);
      });

}

    loadTableData(){
    this.tableService.loadTableData().subscribe(
      data => {
        this.DataArray = data;
        console.log(data);
      });
  }

      onNameClick(find: string){
    this.tableService.onNameClick(find).subscribe(
      data => {
        this.DataArray = data;
        console.log(data);
      });
  }

  ngOnInit() { }


  sendGetRequest(){
    console.log("SEND");
  }


}



// WEBPACK FOOTER //
// C:/Users/re5pect/Desktop/siterepoProject/Admin panel/SiteRepoAdminPanel/src/app/izvestaj/izvestaj.component.ts